import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Section = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 24px;
  border-radius: 16px;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
    pointer-events: none;
  }
`;

const Label = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 500;
  position: relative;
  z-index: 1;
`;

const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
  z-index: 1;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: translateX(4px);
  }

  &::before {
    content: '✨';
    font-size: 20px;
    flex-shrink: 0;
  }
`;

const ItemText = styled.span`
  flex: 1;
`;

const Credits = styled.span`
  font-weight: 700;
  font-size: 20px;
  color: #ffd700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

const CostPerStorySection: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <Section>
      <Label>{t('credits.costLabel', 'Cost per generated story')}</Label>
      <ItemsContainer>
        <Item>
          <ItemText>
            {t('credits.withoutImagesText', 'Without images')}
          </ItemText>
          <Credits>2 {t('credits.credits', 'credits')}</Credits>
        </Item>
        <Item>
          <ItemText>
            {t('credits.withImagesText', 'With images')}
          </ItemText>
          <Credits>4 {t('credits.credits', 'credits')}</Credits>
        </Item>
      </ItemsContainer>
    </Section>
  );
};

export default CostPerStorySection;